import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { getQuestionsAndAnswers } from "../../../store/selectors";
import useRadioAndSelectQuestion from "../hooks/useRadioAndSelectQuestion";
import DropdownQuestion from "../../../components/DropdownQuestion/DropdownQuestion";

interface AnswerObject {
  id: string;
  label: string;
}

interface RadioAndSelectQuestionProps {
  question: Question;
}

export const RadioAndSelectQuestion = ({
  question
}: RadioAndSelectQuestionProps) => {
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];

  const {
    noDamage,
    error,
    handleChange,
    sortedAnswersForSelect,
    answer,
    labelForSelect,
    groupName,
    noDamageLabel,
    showSelectLabel,
    showSelectValue,
    allAnswersSorted
  } = useRadioAndSelectQuestion({ question });
  const [toggleSelect, setToggleSelect] = useState(
    storedAnswer === showSelectValue ||
      (storedAnswer && storedAnswer.toString() !== noDamage.toString())
      ? true
      : false
  );

  return question.metadata?.inputComponent?.toLowerCase() === "RadioSelect".toLowerCase() ? (
    <div className="ch-form__group ch-flex-flow--column-nowrap">
      {error === "radio" && (
        <div className="ch-form__group ch-form__group--error ch-mb--0">
          <span className="ch-form__control-validation ch-mb--1">
            Please choose an option
          </span>
        </div>
      )}
      <div className="ch-mb--3">
        <input
          id={`${groupName}-yes`}
          type="radio"
          name={`${groupName}NeedRepaired`}
          value={showSelectValue}
          className="ch-radio"
          checked={
            answer === showSelectValue ||
            (Boolean(answer) &&
              Boolean(noDamage) &&
              answer.toString() !== noDamage.toString())
          }
          onChange={({ target: { value } }) => {
            setToggleSelect(true);
            handleChange(value);
          }}
        />
        <label
          htmlFor={`${groupName}-yes`}
          className="ch-radio__label ch-radio__label--primary"
        >
          {showSelectLabel}
        </label>
      </div>
      {toggleSelect && (
        <div
          className={`ch-form__group ${
            error === "select" ? "ch-form__group--error" : ""
          }`}
        >
          <label
            htmlFor={`${groupName}Damaged`}
            className="ch-form__control-label"
          >
            {labelForSelect}
          </label>
          {error === "select" && (
            <span className="ch-form__control-validation">
              Please choose an option
            </span>
          )}
          <select
            name={`${groupName}Damaged`}
            className="ch-form__control custom-dropdown ch-color--grey-6"
            onChange={({ target: { value } }) => handleChange(value)}
            value={answer}
          >
            <option value="">Select an option</option>
            {sortedAnswersForSelect.map((answerObject: AnswerObject) => (
              <option key={answerObject.id} value={answerObject.id}>
                {answerObject.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="ch-mb--3">
        <input
          id={`${groupName}-no`}
          type="radio"
          name={`${groupName}NeedRepaired`}
          value={noDamage}
          className="ch-radio"
          checked={
            Boolean(answer) &&
            Boolean(noDamage) &&
            answer.toString() === noDamage.toString()
          }
          onChange={({ target: { value } }) => {
            setToggleSelect(false);
            handleChange(value);
          }}
        />
        <label
          htmlFor={`${groupName}-no`}
          className="ch-radio__label ch-radio__label--primary"
        >
          {noDamageLabel}
        </label>
      </div>
    </div>
  ) : (
    <DropdownQuestion
      id={`${question.id}`}
      labelText=""
      name={`${question.id}`}
      defaultValue={storedAnswer}
      defaultOptionText="Select an option"
      onChange={(event) => handleChange(parseInt(event.target.value))}
      options={allAnswersSorted}
      validationMessage={error === "radio" ? "Please select an option" : null}
    />
  );
};
